import { useState, useEffect } from "react";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Cancel } from "../../Utils/Constants";
import { Btn } from "../../AbstractElements";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateProduct } from "../../ReduxToolkit/Reducers/ProductsReducer";
import { useNavigate } from "react-router-dom";
import { updatePosItems } from "../../services/posItemsHelper";
// import ToolbarBox from "../../AddProduct/ProductTabContents/Common/ToolbarBox";

export default function QuickEdit({ Product, setEdit, Edit }) {
  const [Loading, setLoading] = useState(false);
  const [product, setProduct] = useState({});
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  useEffect(() => {
    setProduct(Product);
  }, [Product]);
  const navigate = useNavigate();

  console.log(Product);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };
  const handleSave = async () => {
    setLoading(true);
    try {
      const productData = {
        ...product,
        sale_price:
          parseFloat(product.sale_price) === 0 || !product.sale_price
            ? parseFloat(product.regular_price)
            : parseFloat(product.sale_price),
      };
      // Dispatch the updateProduct action
      const resp = await dispatch(updateProduct(productData));
      if (resp.payload.success) {
        const updatedProduct = resp.payload.data;
        // Update pos_items using helper function
        await updatePosItems(updatedProduct, dispatch);
        toast.success("Product Updated successfully");
      }
      setLoading(false);
    } catch (e) {
      toast.error(`Failed to save product: ${e.message}`);
      console.error(e);
    }
    setEdit(false);
  };
  return (
    <Col xs={12}>
      <Modal isOpen={Edit} toggle={setEdit} size="lg">
        <ModalHeader toggle={setEdit}>
          Edit Product ( {product.name} )
        </ModalHeader>
        <ModalBody className="custom-input">
          <div className="create-category">
            <Row>
              {/* <Col sm={12} className="m-0">
                <FormGroup>
                  <Label>Product SKU</Label>
                  <Input
                    type="text"
                    name="sku"
                    value={product.sku}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col> */}
              {/* <Col sm={3} className="m-0">
                <FormGroup>
                  <Label>Product Cost</Label>
                  <Input
                    type="number"
                    name="product_cost"
                    value={product.product_cost}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col> */}
              <Col sm={4} className="m-0">
                <FormGroup>
                  <Label>Regular Price</Label>
                  <Input
                    type="number"
                    name="regular_price"
                    value={product.regular_price}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
              <Col sm={4} className="m-0">
                <FormGroup>
                  <Label>Sale Price</Label>
                  <Input
                    type="number"
                    name="sale_price"
                    value={product.sale_price}
                    onChange={(e) => handleChange(e)}
                  />
                </FormGroup>
              </Col>
              {product?.manage_stock && (
                <Col sm={4} className="m-0">
                  <FormGroup>
                    <Label>Stock</Label>
                    <Input
                      disabled={!product?.manage_stock}
                      type="number"
                      name="stock_quantity"
                      value={product.stock_quantity}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
          </div>
        </ModalBody>
        <ModalFooter>
          <Btn
            color="light"
            onClick={() => {
              setEdit(false);
            }}
          >
            {Cancel}
          </Btn>
          <Btn color="primary" onClick={handleSave}>
            {"Update"}
          </Btn>
        </ModalFooter>
      </Modal>
    </Col>
  );
}
